import React from 'react';
import styled from "styled-components";
import useZibi from "../../../zibi/UseZibi";
import Edge from "./Edge";

const WrapperStyled = styled.div`
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    display: grid;
    grid-gap: 15px;
`;


const Edges = () => {
    const [siteEdges] = useZibi('siteEdges');

    return (
        <WrapperStyled>
            {siteEdges && siteEdges.map((edge) => {
                return (
                    <Edge
                        key={edge._id}
                        item={edge}
                    />
                );
            })}
        </WrapperStyled>
    );
};

export default Edges;